import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`

export const Title = styled.h1`
  ${({ theme }) => css`
    font-size: 24px;
    font-weight: 600;
    color: ${theme.colors.secondary};
    margin: 0;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
  `}
`

export const Subtitle = styled.p`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 400;
    color: ${theme.colors.gray.dark};
    margin: 0;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
  `}
`

export const WarningBanner = styled(Box)`
  ${() => css`
    width: 100%;
    padding: 12px 16px;
    background-color: #fffbeb;
    border: 1px solid #f59e0b;
    border-radius: 8px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
  `}
`

export const WarningIconContainer = styled(Box)`
  flex-shrink: 0;
  margin-top: 2px;
  
  svg {
    color: #f59e0b;
    width: 22px;
    height: 19px;
  }
`

export const WarningText = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #92400e;
    line-height: 1.5;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
  `}
`

export const CustomButton = styled.button<{ width?: string | number }>`
  ${({ theme, width }) => css`
    height: 48px;
    border-radius: 8px;
    background: #73A49F;
    color: ${theme.colors.lightest};
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 400;
    font-family: ${theme.fontFamily.openSans}, sans-serif;
    width: ${width || 'auto'};
    min-width: ${width || 'auto'};

    &:hover {
      background: #5d8a85;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;

      &:hover {
        background: #73a49f;
      }
    }

    svg {
      width: 22px;
      height: 22px;
    }

    @media (max-width: ${theme.screenSizes.laptop}) {
      width: 100%;
    }
  `}
`
